var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_shared-key.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_shared-key.js
// module chunks = 168707334958949